export const RANGE_ROW_MIN = 1;
export const RANGE_ROW_MAX = 100;
export const RANGE_ROW_MAX_MESSAGE = 'Maximum of 100 rows allowed.';
export const RANGE_ROW_MIN_MESSAGE = 'Minimum of 1 row required.';
export const RANGE_ROW_REQUIRED_MESSAGE = 'Number of rows is required.';

export function validateRangeRowCount(value) {
  if (value === null || value === undefined || value === '') {
    return {
      isValid: false,
      message: RANGE_ROW_REQUIRED_MESSAGE
    };
  }

  const rowCount = Number(value);

  if (!Number.isFinite(rowCount)) {
    return {
      isValid: false,
      message: 'Number of rows must be a valid number.'
    };
  }

  if (!Number.isInteger(rowCount)) {
    return {
      isValid: false,
      message: 'Number of rows must be a whole number.'
    };
  }

  if (rowCount < RANGE_ROW_MIN) {
    return {
      isValid: false,
      message: RANGE_ROW_MIN_MESSAGE
    };
  }

  if (rowCount > RANGE_ROW_MAX) {
    return {
      isValid: false,
      message: RANGE_ROW_MAX_MESSAGE
    };
  }

  return {
    isValid: true,
    value: rowCount
  };
}

export function validateRangeRows(rows) {
  if (!Array.isArray(rows)) {
    return {
      isValid: false,
      message: RANGE_ROW_REQUIRED_MESSAGE
    };
  }

  return validateRangeRowCount(rows.length);
}

export function assertRangeRows(rows) {
  const validation = validateRangeRows(rows);

  if (!validation.isValid) {
    throw new Error(validation.message);
  }

  return rows;
}

export function assertRangeRowCount(value) {
  const validation = validateRangeRowCount(value);

  if (!validation.isValid) {
    throw new Error(validation.message);
  }

  return validation.value;
}
